module.exports = __webpack_public_path__ + "img/shengdantree.47e304fc.png";